import { render, staticRenderFns } from "./MacroKpi.vue?vue&type=template&id=fdad6d8c&scoped=true"
import script from "./MacroKpi.vue?vue&type=script&lang=js"
export * from "./MacroKpi.vue?vue&type=script&lang=js"
import style0 from "./MacroKpi.vue?vue&type=style&index=0&id=fdad6d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdad6d8c",
  null
  
)

export default component.exports